export enum EFsViewMode {
  CARD = 'CARD',
  LIST = 'LIST',
}
